'use client';

import { useState, useEffect } from 'react';
import HeroSection from './HeroSection';
import FounderStory from './FounderStory';
import MissionValues from './MissionValues';
import ClosingCTA from './ClosingCTA';

interface AboutInteractiveProps {
  className?: string;
}

const AboutInteractive = ({ className = '' }: AboutInteractiveProps) => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  if (!isHydrated) {
    return (
      <div className={`min-h-screen bg-background ${className}`}>
        <HeroSection />
        <FounderStory />
        <MissionValues />
        <ClosingCTA />
      </div>
    );
  }

  return (
    <div className={`min-h-screen bg-background ${className}`}>
      <HeroSection />
      <FounderStory />
      <MissionValues />
      <ClosingCTA />
    </div>
  );
};

export default AboutInteractive;
